import { PATH_NAME } from '../Routes/Pathname';
// import dashboardIcon from '../Assets/Icons/Navbar/dashboardIcon.svg';
// import reportingIcon from '../Assets/Icons/Navbar/reportingIcon.svg';
// import employeesIcon from '../Assets/Icons/Navbar/employeesIcon.svg';
// import campaignIcon from '../Assets/Icons/Navbar/campaignIcon.svg';
// import issuesIcon from '../Assets/Icons/Navbar/issuesIcon.svg';
// import conversationIcon from '../Assets/Icons/Navbar/conversationIcon.svg';
// import orgIcon from '../Assets/Icons/Navbar/orgIcon.svg';
// import integrationIcon from '../Assets/Icons/Navbar/integrationIcon.svg';
// import recordingIcon from '../Assets/Icons/Navbar/recordingIcon.svg';
// import supportIcon from '../Assets/Icons/Navbar/supportIcon.svg';
// import settingsIcon from '../Assets/Icons/Navbar/settingsIcon.svg';
// import alert from '../Assets/Icons/Navbar/alert.svg';
import { matchPath } from 'react-router-dom';
import { AlertOctagonIcon, DocumentIcon, InfoIcon, PeopleIcon, InsightsIcon, AlertIcon, IntegrationIcon, SupportIcon, SettingsIcon, ConversationsIcon, CampaignIcon, IssuesIcon, DashboardIcon, SubscriptionIcon, InboundCallIcon, SupportAgentIcon, SpaceDashboardIcon } from '../Components/Icons/Icons';

export const mainOptions = (pathname) => [
	{
		label: 'Dashboard',
		to: PATH_NAME.DASHBOARD,
		icon: (props) => <DashboardIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME?.DASHBOARD }, pathname),
	},
	{
		label: 'Insights',
		to: PATH_NAME.MOOD_INSIGHTS,
		icon: (props) => <InsightsIcon {...props} />,
		isSelected:
			matchPath({ path: PATH_NAME?.ACTIONABLE_INSIGHTS }, pathname) ||
			matchPath({ path: PATH_NAME?.REPORTING_INSIGHTS }, pathname) ||
			matchPath({ path: PATH_NAME?.MOOD_INSIGHTS }, pathname) ||
			matchPath({ path: PATH_NAME?.CAMPAIGN_INSIGHTS }, pathname),
		// matchPath({ path: PATH_NAME?.CAMPAIGN_ALERT }, pathname),
		subOptions: [
			{
				label: 'Encouraging Vibes',
				to: PATH_NAME.MOOD_INSIGHTS,
				isSelected: matchPath({ path: PATH_NAME?.MOOD_INSIGHTS }, pathname),
				icon: (props) => <InfoIcon {...props} />,
			},
			{
				label: 'Actionable insights',
				to: PATH_NAME.ACTIONABLE_INSIGHTS,
				isSelected: matchPath({ path: PATH_NAME?.ACTIONABLE_INSIGHTS }, pathname),
				icon: (props) => <DocumentIcon {...props} />,
			},
			{
				label: 'Campaign insights',
				to: PATH_NAME.CAMPAIGN_INSIGHTS,
				isSelected: matchPath({ path: PATH_NAME?.CAMPAIGN_INSIGHTS }, pathname),
				icon: (props) => <AlertOctagonIcon {...props} />,
			},
			// {
			// 	label: 'Vulnerability alert',
			// 	to: PATH_NAME.CAMPAIGN_ALERT,
			// 	isSelected: matchPath({ path: PATH_NAME?.CAMPAIGN_ALERT }, pathname),
			// 	icon : (props) => <InfoOutlineIcon  {...props} />
			// },
		],
	},
	{
		label: 'Exit Interview',
		to: PATH_NAME.EXIT_INTERVIEW_DASHBOARD,
		icon: (props) => <SpaceDashboardIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME?.EXIT_INTERVIEW_DASHBOARD }, pathname),
	},
	// {
	// 	label: 'Leading turnover',
	// 	to: PATH_NAME.LEADING_TURNOVER,
	// 	icon: leadingIcon,
	// 	isSelected: matchPath({ path: PATH_NAME.LEADING_TURNOVER }, pathname),
	// },
	{
		label: 'Alert',
		to: PATH_NAME.CAMPAIGN_ALERT,
		icon: (props) => <AlertIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME?.CAMPAIGN_ALERT }, pathname),
	},
	{
		label: 'Employees',
		to: PATH_NAME.EMPLOYEES_LIST,
		icon: (props) => <PeopleIcon {...props} />,
		isSelected:
			matchPath({ path: PATH_NAME.EMPLOYEES_LIST }, pathname) ||
			matchPath({ path: PATH_NAME.EMPLOYEE_ADD }, pathname) ||
			matchPath({ path: PATH_NAME.EMPLOYEE_EDIT }, pathname),
	},
	{
		label: 'Campaign',
		to: PATH_NAME.CAMPAIGN_LIST,
		icon: (props) => <CampaignIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME.CAMPAIGN_LIST }, pathname) || matchPath({ path: PATH_NAME.CAMPAIGN_EDIT }, pathname),
	},
	{
		label: 'Issues',
		to: PATH_NAME.ISSUES_RAISED,
		icon: (props) => <IssuesIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME.ISSUES_RAISED }, pathname),
	},
	// {
	// 	label: 'Critical alerts',
	// 	to: PATH_NAME.CRITICAL_RISK,
	// 	icon: orgIcon,
	// 	isSelected: matchPath({ path: PATH_NAME.CRITICAL_RISK }, pathname),
	// },

	{
		label: 'Conversations',
		to: PATH_NAME.CONVERSATIONS,
		icon: (props) => <ConversationsIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME.CONVERSATIONS }, pathname),
	},
	{
		label: 'Integration',
		to: PATH_NAME.INTEGRATION,
		icon: (props) => <IntegrationIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME.INTEGRATION }, pathname),
	},
	,
	{
		label: 'Support',
		to: PATH_NAME.SUPPORT,
		icon: (props) => <SupportIcon {...props} />,
		// upcoming: true,
		isSelected: matchPath({ path: PATH_NAME.SUPPORT }, pathname),
	},
	{
		label: 'Settings',
		to: PATH_NAME.SETTINGS,
		icon: (props) => <SettingsIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME.SETTINGS }, pathname),
	},
	{
		label: 'Subscription',
		to: PATH_NAME.SUBSCRIPTION,
		icon: (props) => <SubscriptionIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME.SUBSCRIPTION }, pathname),
	},
	{
		label: 'InboundCalls',
		to: PATH_NAME.INBOUND_CALL_LIST,
		icon: (props) => <InboundCallIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME.INBOUND_CALL_LIST }, pathname),
	},
	{
		label: 'Agents',
		to: PATH_NAME.AGENTS_LIST,
		icon: (props) => <SupportAgentIcon {...props} />,
		isSelected: matchPath({ path: PATH_NAME.AGENTS_LIST }, pathname),
	},
];